module.exports = __webpack_public_path__ + "img/皇冠.0ddebda2.png";